const RECENT_KEYWORDS_KEY = 'cyclone_recent_keywords';
const MAX_RECENT_KEYWORDS = 20;

export interface RecentKeyword {
  keyword: string;
  timestamp: number;
}

export const getRecentKeywords = (): RecentKeyword[] => {
  try {
    const stored = localStorage.getItem(RECENT_KEYWORDS_KEY);
    if (!stored) return [];
    return JSON.parse(stored);
  } catch {
    return [];
  }
};

export const addRecentKeyword = (keyword: string): void => {
  try {
    if (!keyword.trim()) return;

    const keywords = getRecentKeywords();
    const trimmedKeyword = keyword.trim();

    const existingIndex = keywords.findIndex((k) => k.keyword.toLowerCase() === trimmedKeyword.toLowerCase());
    if (existingIndex !== -1) {
      keywords.splice(existingIndex, 1);
    }

    const newKeyword: RecentKeyword = {
      keyword: trimmedKeyword,
      timestamp: Date.now(),
    };

    keywords.unshift(newKeyword);

    if (keywords.length > MAX_RECENT_KEYWORDS) {
      keywords.splice(MAX_RECENT_KEYWORDS);
    }

    localStorage.setItem(RECENT_KEYWORDS_KEY, JSON.stringify(keywords));
  } catch (error) {
    console.error('Failed to save recent keyword:', error);
  }
};

export const removeRecentKeyword = (keyword: string): void => {
  try {
    const keywords = getRecentKeywords();
    const filtered = keywords.filter((k) => k.keyword.toLowerCase() !== keyword.toLowerCase());
    localStorage.setItem(RECENT_KEYWORDS_KEY, JSON.stringify(filtered));
  } catch (error) {
    console.error('Failed to remove recent keyword:', error);
  }
};

export const clearRecentKeywords = (): void => {
  try {
    localStorage.removeItem(RECENT_KEYWORDS_KEY);
  } catch (error) {
    console.error('Failed to clear recent keywords:', error);
  }
};
